export const SET_PARTNER_PROFILE_STATE = 'SET_PARTNER_PROFILE_STATE'

export const setPartnerProfile = (newProfileIndex, hasBeenSet) => ({
  type: SET_PARTNER_PROFILE_STATE,
  newProfileIndex,
  hasBeenSet
})
